import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { PendingChangesService } from '../services/pending-changes.service';

export const PendingChangesGuard: CanDeactivateFn<boolean> = (_component, _currentRoute, _currentState, _nextState) => {
  const pendingChangesService = inject(PendingChangesService);

  if (pendingChangesService.hasUnsavedChanges()) {
    return confirm('You have unsaved changes. Are you sure you want to close without saving?');
  }

  return true;
};
